#import "../fragments/entity-summary-fragment.graphql"

query GetEntitySummary($id: ID!, $summaryType: SummaryType!) {
    entitySummary(id: $id, summaryType: $summaryType) {
        ...EntitySummaryFragment
    }
}
